import React from 'react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import Banner from '../components/Banner';
import Reaction from '../components/Reaction';
import Contact from '../components/Contact';
import LastUpdate from '../components/LastUpdate';

const FaqStrukApprove = () => {
    React.useEffect(() => {
        window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
    }, []);
    
    return (
      <div className="bg-white min-h-screen  flex flex-col">
        <Navbar />
        <Banner
            image={process.env.REACT_APP_S3 + "banner_faq.png"} 
            beforePage="FAQ"
            currentPage="Detail FAQ" 
        />
        <div className="mx-auto px-4 md:px-24 w-full relative z-10 mb-16">
            <div className="rounded-2xl md:rounded-3xl">
                <div className="mb-10 md:mb-16 max-w-4xl">
                    <h1 className="text-2xl md:text-3xl lg:text-3xl font-bold text-[#101828] mb-6 leading-snug">
                        Bagaimana cara upload struk yang benar?
                    </h1>
                </div>
                <div className="grid grid-cols-1 gap-8">
                  <div className="w-full">
                    <label className="text-[#101828] text-md md:text-md">
                      <strong>Kenapa struk saya ditolak?</strong>
                    </label>
                    <ol className="list-decimal pl-5 mt-4 text-[#475467] mb-10">
                      <li className="mb-4 font-bold">
                        Buka menu Upload yang tersedia di halaman beranda.
                      </li>
                      <li className="mb-4 font-bold">
                        Baca dan pahami panduan unggah struk sebelum melanjutkan.
                        <img 
                            src={process.env.REACT_APP_S3+"struk_approve_1.png"}
                            class="block mx-auto h-[350px] md:h-[420px] w-auto object-contain my-8"
                        />
                      </li>
                      <li className="mb-4 font-bold">
                        Pilih metode unggah struk yang tersedia:
                        <ol className="list-[upper-alpha] pl-5 text-[#475467] mt-4 font-bold">
                            <li className="mb-4">Menggunakan Kamera
                                <ul className='list-disc pl-5 text-[#475467] mt-4'>
                                    <li className="mb-4 font-normal">
                                        Gunakan kamera untuk memotret struk secara langsung.
                                    </li>
                                    <li className="mb-4 font-normal">
                                        Pastikan struk tidak terlipat, tidak buram, dan seluruh bagian struk terlihat jelas di dalam area kamera.
                                        <img 
                                            src={process.env.REACT_APP_S3+"struk_approve_2.png"}
                                            class="block mx-auto h-[350px] md:h-[420px] w-auto object-contain my-8"
                                        />
                                    </li>
                                </ul>
                            </li>
                            <li className="mb-4">Unggah File (Attach File)
                                <ul className='list-disc pl-5 text-[#475467] mt-4'>
                                    <li className="mb-4 font-normal">
                                        Pilih file dari galeri perangkat Anda.
                                    </li>
                                    <li className="mb-4 font-normal">
                                       Format yang didukung: PDF atau gambar (image).
                                    </li>
                                    <li className="mb-4 font-normal">
                                       Metode ini disarankan untuk struk digital.
                                       <img 
                                        class="block mx-auto h-[350px] md:h-[420px] w-auto object-contain my-8"
                                        src={process.env.REACT_APP_S3+"struk_approve_3.png"}/>

                                        <img 
                                        class="block mx-auto h-[350px] md:h-[420px] w-auto object-contain my-8"
                                        src={process.env.REACT_APP_S3+"struk_approve_4.png"}/>
                                    </li>
                                </ul>
                            </li>
                        </ol>
                      </li>
                      <li className="mb-4">
                        Setelah file atau foto struk terunggah dengan jelas, klik tombol Submit.
                      </li>
                      <li className="mb-4">
                        Jika proses berhasil, struk Anda telah berhasil diunggah.
                        <img 
                        class="block mx-auto h-[350px] md:h-[420px] w-auto object-contain my-8"
                        src={process.env.REACT_APP_S3+"struk_approve_5.png"}/>
                      </li>
                    </ol>
                  </div>
                </div>
                <LastUpdate/>
            </div>
        </div>
        <Contact />
        <Footer />
      </div>
    );
}

export default FaqStrukApprove;